import { Link } from 'react-router-dom';
import { SCREENS } from '../lib/screenRegistry';
import './RegisterSelect.css';

const LOGO = encodeURI('/Assets/logo/Mentology Logo.png');

export default function RegisterSelect() {
  return (
    <div className="register-select-page" data-screen-id={SCREENS.ELT02}>
      <div className="register-select-logo-wrap">
        <img
          src={LOGO}
          alt="Mentology"
          className="register-select-logo brand-logo"
          onError={(e) => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      </div>
      <div className="register-select-content">
        <h1 className="section-header register-select-heading">Select Your Registration Pathway</h1>
        <div className="button-control-group">
          <Link to="/register-code" className="btn-primary">
            Have Demo Code
          </Link>
          <Link to="/register-org" className="btn-primary">
            ORGANISATION MENTOR REGISTRATION
          </Link>
          <Link to="/register-private" className="btn-primary">
            INDIVIDUAL MENTEE REGISTRATION
          </Link>
        </div>
        <div className="button-control-group" style={{ marginTop: '0.75rem' }}>
          <Link to="/" className="btn-primary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
